import { createBrowserHistory } from 'history'

const browserHistory = createBrowserHistory()

export const getHistory = () => {
    return browserHistory
}

export default browserHistory
